import { Component, Inject } from '@angular/core';
import { SchoolApiService } from '../../Services/schoolApi.service';
import { BaseComponent } from '../../Pages/base.component';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IResponse } from '../../Models/response.model';
import { DOMAIN } from '../../../configurations/defaultConfigs';
import { NATIONAL_PAGES, SCHEMA_TYPE } from '../../constants';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './career-form.component.html',
  styleUrl: './career-form.component.css',
})
export class CareerFormComponent extends BaseComponent {
  candidateForm: FormGroup;
  jobOptions: any = {
    national: [
      {
        en: 'French teacher',
        fr: 'Professeur de français',
        ar: ' معلم لغة فرنسية',
      },
      {
        en: 'English teacher',
        fr: 'Professeur d’anglais ',
        ar: 'معلم لغة إنجليزية',
      },
      {
        en: ' Arabic teacher',
        fr: 'Professeur d’arabe',
        ar: 'معلم لغة عربية',
      },
      {
        en: 'Science teacher',
        fr: 'Professeur de sciences',
        ar: 'معلم علوم',
      },
      {
        en: 'Math teacher',
        fr: 'Professeur de maths',
        ar: 'معلم رياضيات',
      },
      {
        en: 'Social studies teacher',
        fr: 'Professeur de matières nationales',
        ar: 'معلم دراسات اجتماعية ',
      },
      {
        en: 'Physics teacher',
        fr: 'Professeur de physique',
        ar: 'معلم فيزياء',
      },
      {
        en: 'Chemistry teacher',
        fr: 'Professeur de chimie',
        ar: 'معلم كيمياء',
      },
      {
        en: 'Biology teacher',
        fr: 'Professeur de biologie ',
        ar: 'معلم أحياء',
      },
      {
        en: 'Philosophy teacher',
        fr: 'Professeur de philosophie',
        ar: 'معلم فلسفة',
      },
      {
        en: 'Psychology teacher',
        fr: 'Professeur de psychologie',
        ar: 'معلم علم نفس',
      },
      {
        en: 'History teacher',
        fr: 'Professeur d’histoire',
        ar: 'معلم تاريخ',
      },
      {
        en: 'Geography teacher',
        fr: 'Professeur de géographie',
        ar: 'معلم جغرافيا',
      },
    ],
    bac: [
      {
        en: 'French',
        fr: 'Français ',
        ar: 'اللغة الفرنسية',
      },
      { en: 'Philosophy ', fr: 'PHILO ', ar: 'الفلسفة' },
      {
        en: 'History-Geography',
        fr: 'HISTOIRE-GEO ',
        ar: 'التاريخ والجغرافيا',
      },
      {
        en: 'Life and Earth Sciences',
        fr: 'SVT (Sciences de la Vie et de la Terre)',
        ar: 'علوم الحياة والأرض',
      },
      { en: 'MATHS ', fr: 'Mathematics ', ar: 'الرياضيات' },
      {
        en: 'Physics and Chemistry',
        fr: 'SPC (Sciences Physiques et Chimiques)',
        ar: 'الفيزياء والكيمياء',
      },
      {
        en: 'Modern Foreign Language A',
        fr: 'LVA (Langue Vivante A)',
        ar: 'اللغة الحية الأولى',
      },
      {
        en: 'Modern Foreign Language B',
        fr: 'LVB (Langue Vivante B)',
        ar: 'اللغة الحية الثانية',
      },
      {
        en: 'Physical Education',
        fr: 'EPS (Éducation Physique et Sportive)',
        ar: 'التربية البدنية',
      },
      {
        en: 'Economics and Social Sciences',
        fr: 'SES (Sciences Économiques et Sociales)',
        ar: 'العلوم الاقتصادية والاجتماعية',
      },
      {
        en: 'History, Geography, Geopolitics, and Political Sciences',
        fr: 'HGGSP',
        ar: 'التاريخ والجغرافيا والجغرافيا السياسية والعلوم السياسية',
      },
      {
        en: 'Economics and Social Sciences ',
        fr: 'ES ',
        ar: 'الاقتصاد والعلوم الاجتماعية',
      },
      { en: 'Literature ', fr: 'LITTÉRATURE ', ar: 'الأدب' },
      {
        en: 'Mathematics Components',
        fr: 'MATHS COMPOSANTS',
        ar: 'مكونات الرياضيات',
      },
      { en: 'Spanish', fr: 'ESPAGNOL', ar: 'اللغة الإسبانية' },
      {
        en: 'Technology / Digital and Technological Sciences',
        fr: 'TECHNO/SNT',
        ar: 'التكنولوجيا / العلوم الرقمية والتكنولوجيا',
      },
    ],
  };
  domainJobOptions: any = this.jobOptions[DOMAIN];
  selectedFile: File | null = null;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<CareerFormComponent>,
    schoolApiService: SchoolApiService
  ) {
    super(schoolApiService);
    this.candidateForm = this.fb.group({
      name: ['', Validators.required],
      birthDate: ['', Validators.required],
      birthPlace: ['', Validators.required],
      certificate: ['', Validators.required],
      certificateDate: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      homePhone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      portablePhone: [
        '',
        [Validators.required, Validators.pattern('^[0-9]*$')],
      ],
      job: ['', Validators.required],
      otherJob: [''],
    });

    this.candidateForm.get('job')?.valueChanges.subscribe((value) => {
      if (value !== 'Other') {
        this.candidateForm.get('otherJob')?.setValue('');
      }
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.selectedFile = file;
    } else {
      alert(this.translate.instant('ONLY_PDF_ALERT'));
      event.target.value = '';
    }
  }

  onSubmit(): void {
    /// Check for valid form
    const isValidForm: boolean =
      this.candidateForm.valid && this.selectedFile !== null;
    if (!isValidForm) return;

    /// Prepare form data request
    const applicationRequest = {
      domainType: DOMAIN,
      schemaType: SCHEMA_TYPE.CAREER,
      articleType: NATIONAL_PAGES.CAREERS,
      name: this.candidateForm.get('name')?.value,
      birthDate: this.candidateForm.get('birthDate')?.value,
      birthPlace: this.candidateForm.get('birthPlace')?.value,
      certificate: this.candidateForm.get('certificate')?.value,
      certificateDate: this.candidateForm.get('certificateDate')?.value,
      address: this.candidateForm.get('address')?.value,
      email: this.candidateForm.get('email')?.value,
      homePhone: this.candidateForm.get('homePhone')?.value,
      portablePhone: this.candidateForm.get('portablePhone')?.value,
      job: this.candidateForm.get('otherJob')?.value.length
        ? this.candidateForm.get('otherJob')?.value
        : this.candidateForm.get('job')?.value,
      brief: this.candidateForm.get('brief')?.value,
      cv: this.selectedFile as Blob,
    };
    /// Send data to Backend
    this.schoolApiService
      .submitCareerApplication(applicationRequest)
      .subscribe((data: IResponse<Boolean>) => {
        if (data.payload) {
          alert(this.translate.instant('FORM_SUBMIT_SUCCESS'));
          this.dialogRef.close(true);
        } else {
          alert(this.translate.instant('FORM_SUBMIT_FAIL'));
        }
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
